function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "package-commission_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65.72 38.76h8a45.89 45.89 0 010 91.77h-8z",
  fill: "none"
})), /*#__PURE__*/React.createElement("style", null, ".package-commission_svg__cls-4,.package-commission_svg__cls-6{fill:none;stroke:#0e5b7c;stroke-linecap:round}.package-commission_svg__cls-4{stroke-linejoin:round}.package-commission_svg__cls-6{stroke-miterlimit:10}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M65.72 38.76h8a45.89 45.89 0 010 91.77h-8z",
  strokeLinejoin: "round",
  stroke: "#0e5b7c",
  strokeLinecap: "round",
  fill: "#6e9db0"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#package-commission_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  className: "package-commission_svg__cls-4",
  d: "M66.67 42.16h56.17M66.67 48.7h56.17M66.67 55.23h56.17M66.67 61.77h56.17M66.67 68.3h56.17M66.67 74.84h56.17M66.67 81.38h56.17M66.67 87.91h56.17M66.67 94.45h56.17M66.67 100.98h56.17M66.67 107.52h56.17M66.67 114.05h56.17M66.67 120.59h56.17M66.67 127.13h56.17"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 63.38,
  cy: 84.64,
  r: 45.88,
  strokeMiterlimit: 10,
  fill: "#f8f8f8",
  stroke: "#0e5b7c",
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "package-commission_svg__cls-6",
  cx: 63.38,
  cy: 84.31,
  r: 36.32
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M45.09 84.34a3.29 3.29 0 01.8-2.2 3 3 0 012.41-.93H51V74.4a17.62 17.62 0 01.92-5.69 13.1 13.1 0 017.48-8 16.83 16.83 0 016.6-1.22 15.49 15.49 0 014.62.65 12.93 12.93 0 013.69 1.8 13.57 13.57 0 012.85 2.71A20.54 20.54 0 0179.33 68l-3.91 2.46a4.82 4.82 0 01-2.57.62 3.45 3.45 0 01-2.29-1.18 11.89 11.89 0 00-2.17-1.83 4.46 4.46 0 00-2.37-.6 4.32 4.32 0 00-3.8 1.78A8.9 8.9 0 0061 74.37v6.84h12v3.72a2 2 0 01-.21.9 2.61 2.61 0 01-.56.78 2.94 2.94 0 01-.86.55 2.85 2.85 0 01-1.08.2H61v4.92a8.08 8.08 0 01-.71 3.42 11.21 11.21 0 01-1.91 2.85 28.06 28.06 0 012.84-.48 22.68 22.68 0 012.87-.18h15.8v4a3.65 3.65 0 01-.3 1.41 4.28 4.28 0 01-.83 1.31 4.09 4.09 0 01-1.31.95 4 4 0 01-1.72.36H45.66v-5.86a9.82 9.82 0 002-.6 6.18 6.18 0 001.68-1 4.73 4.73 0 001.17-1.52 4.54 4.54 0 00.44-2v-7.58h-5.86z",
  fill: "#0e5b7c"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fbc282",
  strokeLinejoin: "round",
  stroke: "#0e5b7c",
  strokeLinecap: "round",
  d: "M105.74 23.14l7.17-3.67 4.37 6.77 8.05.4.4 8.05 6.77 4.37-3.67 7.17 3.67 7.17-6.77 4.37-.4 8.05-8.05.4-4.37 6.77-7.17-3.67-7.17 3.67-4.37-6.77-8.05-.4-.4-8.05-6.77-4.37 3.67-7.17-3.67-7.17 6.77-4.37.4-8.05 8.05-.4 4.37-6.77 7.17 3.67z"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "package-commission_svg__cls-6",
  cx: 98.16,
  cy: 38.65,
  r: 4.12
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "package-commission_svg__cls-6",
  cx: 113.32,
  cy: 53.81,
  r: 4.12
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "package-commission_svg__cls-6",
  d: "M95.7 56.27l20.08-20.08"
});

function SvgPackageCommission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "package-commission_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default SvgPackageCommission;